import { render, staticRenderFns } from "./ModelLoadingPage.vue?vue&type=template&id=62c7ef83"
import script from "./ModelLoadingPage.vue?vue&type=script&lang=js"
export * from "./ModelLoadingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports